// 部所選択モーダルの JS 制御

document.addEventListener('turbolinks:load', function () {
  $('.improved-header__busho-name[data-toggle="tooltip"]').tooltip({ template: '<div class="tooltip busho-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>' });
  $('[data-toggle="tooltip"]:not(.improved-header__busho-name)').tooltip();

  const modal = document.getElementById('bushoSelectionModal');
  if (!modal) return;

  const isConfirmPage = window.location.pathname.includes('/quotation_order/confirm');

  // モーダルを自動表示（static backdrop で閉じ不可）
  if (!isConfirmPage) {
    $(modal).modal('show');
  }

  const bushoSelect = modal.querySelector('.js-busho-select');
  const ecCompanyGroup = modal.querySelector('.js-ec-company-group');
  const ecCompanySelect = modal.querySelector('.js-ec-company-select');
  const tokuisakiName = modal.querySelector('.js-tokuisaki-name');
  const options = window.bushoOptions || [];

  // 部所選択変更時
  bushoSelect.addEventListener('change', function () {
    const selectedBusho = this.value;
    const matched = options.filter(o => o.busho_code === selectedBusho);

    if (matched.length > 1) {
      // 同一部所コードで得意先が複数 → 得意先リストを表示・更新
      ecCompanyGroup.style.display = '';
      const selectOptions = matched.map(o =>
        `<option value="${o.ec_company_code}">${o.ec_company_code}</option>`
      ).join('');
      ecCompanySelect.innerHTML = selectOptions;
      updateTokuisakiName(matched[0]);
    } else {
      ecCompanyGroup.style.display = 'none';
      // 得意先が1件の場合もセレクトの値を選択中の部所に対応するEC得意先コードに更新する
      // （更新しないとフォーム送信時に古い部所の ec_company_code が送られ、
      //   session[:selected_ec_company_code] が連動しなくなる）
      if (matched[0]) {
        ecCompanySelect.innerHTML = `<option value="${matched[0].ec_company_code}">${matched[0].ec_company_code}</option>`;
      }
      updateTokuisakiName(matched[0] || {});
    }
  });

  // 得意先コード変更時
  ecCompanySelect.addEventListener('change', function () {
    const selectedBusho = bushoSelect.value;
    const selectedEc = this.value;
    const matched = options.find(o => o.busho_code === selectedBusho && o.ec_company_code === selectedEc);
    updateTokuisakiName(matched || {});
  });

  function updateTokuisakiName(option) {
    tokuisakiName.textContent = option.tokuisaki_name || '';
  }

  // 初期表示: モーダルオープン時に現在選択中の部所・得意先に対応する得意先名を表示
  (function initTokuisakiName() {
    const initBusho = bushoSelect.value;
    if (!initBusho) return;
    const initEc = ecCompanySelect ? ecCompanySelect.value : null;
    const initOption = initEc
      ? options.find(o => o.busho_code === initBusho && o.ec_company_code === initEc)
      : options.find(o => o.busho_code === initBusho);
    updateTokuisakiName(initOption || {});
  })();

  if (isConfirmPage) {
    const form = document.getElementById('busho-selection-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(form);
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'X-CSRF-Token': csrfToken,
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.changed) {
              window.location.href = data.redirect_to;
            } else {
              $(modal).modal('hide');
            }
          });
      });
    }
  }
});

// 再見積モーダルは部所・得意先が固定（disabled）のためJS制御不要
// モーダルを決定ボタン押下せずに閉じた場合は見積詳細画面に戻る
document.addEventListener('turbolinks:load', function () {
  const reModal = document.getElementById('reQuotationBushoModal');
  if (!reModal) return;

  let formSubmitted = false;
  const reForm = document.getElementById('re-quotation-busho-form');
  if (reForm) {
    reForm.addEventListener('submit', function () {
      formSubmitted = true;
    });
  }

  $(reModal).on('hidden.bs.modal', function () {
    if (!formSubmitted && reModal.dataset.noRedirect !== 'true') {
      const historyId = reModal.getAttribute('data-history-id');
      if (historyId) {
        window.location.href = '/quotation_order_histories/' + historyId;
      }
    }
  });
});
